//
//
//
//
//
//
//

// import _ from 'underscore'
// import DIC from '@/index/dictonary'

export default {
  props: {
  },
  data: function () {
    let beginTime = this.$route.query.beginTime || moment().format('YYYY-MM-DD');
    let endTime = this.$route.query.endTime || moment().format('YYYY-MM-DD');
    return {
      search: {
        beginTime: beginTime,
        endTime: endTime
      }
    }
  },
  watch: {
  },
  components: {
    ReportOrderChart: () => import('./components/ReportOrderChart/index.vue'),
    ReportTodayOrderStatistics: () => import('./components/ReportTodayOrderStatistics/index.vue'),
    ReportGoodsStatistics: () => import('./components/ReportGoodsStatistics/index.vue')
  },
  mounted () {

  },
  methods: {

  }
}
